/**
 * Auth payload for screening-interview client beacons (interview events + proctoring).
 * Prefers clientToken (interview phase); falls back to roomToken (setup phase).
 */
export type ScreeningInterviewAuthPayload = { clientToken: string } | { roomToken: string }

export function getScreeningInterviewAuthPayload(): ScreeningInterviewAuthPayload | null {
    if (typeof sessionStorage === 'undefined') {
        return null
    }

    const clientToken = sessionStorage.getItem('clientToken')
    if (clientToken) {
        return { clientToken }
    }

    const roomToken = sessionStorage.getItem('roomToken')
    if (roomToken) {
        return { roomToken }
    }

    return null
}
